import { render, staticRenderFns } from "./LinkOrRegister.vue?vue&type=template&id=3689d89c"
import script from "./LinkOrRegister.vue?vue&type=script&lang=ts"
export * from "./LinkOrRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports